// Svelte component loader driven by data attributes.
//
// Any element with data-svelte-component="name" gets the matching component
// from app/javascript/components/<name>.svelte mounted into it, with
// data-props (JSON) passed through as props.
import { mount } from 'svelte'

const componentModules = import.meta.glob('./components/**/*.svelte', { eager: true })

function findComponent(name) {
  const module = componentModules[`./components/${name}.svelte`]
  if (module && module.default) return module.default
  console.error(`Svelte component "${name}" not found. Available:`, Object.keys(componentModules))
  return null
}

function mountComponent(element) {
  if (element.dataset.svelteMounted) return

  const Component = findComponent(element.dataset.svelteComponent)
  if (!Component) return

  const props = JSON.parse(element.dataset.props || '{}')
  element.innerHTML = ''
  mount(Component, { target: element, props })
  element.dataset.svelteMounted = true
}

export function mountSvelteComponents() {
  document.querySelectorAll('[data-svelte-component]').forEach(mountComponent)
}

// Re-run after Turbo navigations and on initial load.
document.addEventListener('turbo:load', mountSvelteComponents)
document.addEventListener('DOMContentLoaded', mountSvelteComponents)
